import { render, staticRenderFns } from "./TimeslotCollectionConfigModal.vue?vue&type=template&id=e53509a2&"
import script from "./TimeslotCollectionConfigModal.vue?vue&type=script&lang=js&"
export * from "./TimeslotCollectionConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports